import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import React from 'react';
import BaseButton from './Button';
import IconButton from '../iconButton';

class Button extends React.PureComponent {
  constructor() {
    let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    super(props);
  }

  render() {
    const props = _Object$assign({}, this.props);

    const hasIcon = Boolean(props.icon || props.iconType); // TODO: iconType needs to be confirmed

    const isLoading = Boolean(props.loading);
    const isDisabled = Boolean(props.disabled);

    if (hasIcon || isLoading && !isDisabled) {
      return /*#__PURE__*/React.createElement(IconButton, _Object$assign({}, props));
    } else {
      return /*#__PURE__*/React.createElement(BaseButton, _Object$assign({}, props));
    }
  }

}

Button.propTypes = _Object$assign(_Object$assign({}, BaseButton.propTypes), IconButton.propTypes);
export default Button;